import { render, staticRenderFns } from "./aviso-2fa.vue?vue&type=template&id=fa024596&scoped=true&"
import script from "./aviso-2fa.component.ts?vue&type=script&lang=ts&"
export * from "./aviso-2fa.component.ts?vue&type=script&lang=ts&"
import style0 from "./aviso-2fa.vue?vue&type=style&index=0&id=fa024596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa024596",
  null
  
)

export default component.exports